import EndPointSection from "@components/Delivery/DeliveryDetails/EndPointSection";
import ComponentContainer from "@components/Delivery/shared/components/ComponentContainer";
import { Box, Divider, Grid, Paper, Typography } from "@mui/material";
import type { Doc } from "@types_def/models/delivery.types";
import { DeliveryStatus, DeliveryType } from "@types_def/models/delivery.types";
import { useTranslation } from "react-i18next";
import { Upload } from "@/components/common/upload";
import type { EndPointSectionFieldsFragment } from "@/libs/generated/operations";

type Props = {
  delivery: EndPointSectionFieldsFragment & {
    id: number;
    type: DeliveryType;
    status: DeliveryStatus;
  };
  docs: Doc[];
  validationDocs: Doc[];
};

export function PhotosCard({ delivery, docs, validationDocs }: Props) {
  const { t } = useTranslation();

  return (
    <Grid size={{ xs: 12 }}>
      <Paper
        elevation={4}
        sx={{ backgroundColor: "#E7E6F7", borderRadius: 1, padding: "20px", height: "100%" }}
      >
        {[
          DeliveryStatus.SET,
          DeliveryStatus.PICKUP_CLIENT,
          DeliveryStatus.PICKUP_DRIVER,
          DeliveryStatus.ONGOING,
          DeliveryStatus.DELIVERED,
          DeliveryStatus.ALERT,
          DeliveryStatus.SWAP_PICKUP_DRIVER,
          DeliveryStatus.SWAP_IN_TRANSIT,
          DeliveryStatus.SWAP_PICKUP_CLIENT,
          DeliveryStatus.SWAP_DELIVERED,
          DeliveryStatus.COMPLETED,
        ].includes(delivery.status) && delivery.vehicles.length > 0 ? (
          <ComponentContainer title={t("delivery.photos-documents")}>
            <EndPointSection delivery={delivery} index={0} isAdmin={false} />
            <Divider orientation="horizontal" sx={{ marginY: 2, backgroundColor: "#E7E6F7" }} />
            {delivery.type === DeliveryType.TWO_WAY_DELIVERY ? (
              <EndPointSection delivery={delivery} index={1} isAdmin={false} />
            ) : null}
          </ComponentContainer>
        ) : null}

        <Divider orientation="horizontal" sx={{ marginY: 2, backgroundColor: "#E7E6F7" }} />

        <Box>
          <Typography textTransform="capitalize" variant="body1">
            {t("delivery.documents-of-departure")}
          </Typography>
          {docs.length > 0 ? (
            <Upload.Root>
              {docs.map((file) => (
                <Upload.Item
                  canEdit={false}
                  key={file.key}
                  meta={{ folder: "delivery", subFolder: delivery.id.toString() }}
                  value={file}
                />
              ))}
            </Upload.Root>
          ) : (
            <Typography sx={{ margin: 2 }} textTransform="capitalize" variant="body1">
              {t("common.shared.no-data")}
            </Typography>
          )}
        </Box>

        <Divider orientation="horizontal" sx={{ marginY: 2, backgroundColor: "#E7E6F7" }} />

        <Box>
          <Typography textTransform="capitalize" variant="body1">
            {t("delivery.validation-documents")}
          </Typography>
          {validationDocs.length > 0 ? (
            <Upload.Root>
              {validationDocs.map((file) => (
                <Upload.Item
                  canEdit={false}
                  key={file.key}
                  meta={{ folder: "delivery", subFolder: delivery.id.toString() }}
                  value={file}
                />
              ))}
            </Upload.Root>
          ) : (
            <Typography sx={{ margin: 2 }} textTransform="capitalize" variant="body1">
              {t("common.shared.no-data")}
            </Typography>
          )}
        </Box>
      </Paper>
    </Grid>
  );
}
